// extracted by mini-css-extract-plugin
export var askAiIcon = "_kv-9";
export var container = "_kv-0";
export var groupSeparator = "_kv-a";
export var highlight = "_kv-4";
export var resultIcon = "_kv-5";
export var resultItem = "_kv-7";
export var resultSubtitle = "_kv-3";
export var resultTitle = "_kv-2";
export var resultsList = "_kv-1";
export var searchGroup = "_kv-6";
export var selected = "_kv-8";